import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import { CommentDataModel } from "features/stock-ordering/core/domain/comment-data.model";
import {
  GetNoticeCommentsRepository,
  GetNoticeCommentsResponse,
} from "features/stock-ordering/data/stock-ordering.repository";

export enum GetNoticeCommentsState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: GetNoticeCommentsState;
  message: string;
  data: CommentDataModel | undefined;
}

const initialState: InitialState = {
  status: GetNoticeCommentsState.initial,
  message: "",
  data: undefined,
};

export const getNoticeComments = createAsyncThunk(
  "getNoticeComments",
  async (param: string, { rejectWithValue }) => {
    try {
      const response: GetNoticeCommentsResponse =
        await GetNoticeCommentsRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

export const getNoticeCommentsSlice = createSlice({
  name: "getNoticeComments",
  initialState,
  reducers: {
    resetGetNoticeComments: (state) => {
      state.status = GetNoticeCommentsState.initial;
      state.data = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getNoticeComments.pending, (state) => {
        state.status = GetNoticeCommentsState.inProgress;
      })
      .addCase(getNoticeComments.fulfilled, (state, action) => {
        if (action.payload) {
          const { message, data } = action.payload;
          state.status = GetNoticeCommentsState.success;
          state.message = message;
          state.data = data;
        }
      })
      .addCase(getNoticeComments.rejected, (state, action) => {
        state.status = GetNoticeCommentsState.fail;
        state.message = action.payload as string;
        state.data = undefined;
      });
  },
});

export const selectGetNoticeComments = (state: RootState) =>
  state.getNoticeComments;
export const { resetGetNoticeComments } = getNoticeCommentsSlice.actions;
export default getNoticeCommentsSlice.reducer;
